<template>
  <div class="page" id="featureDetail" v-bind:class="{ 'show-mobile' : $vuetify.breakpoint.smAndDown }">
    <div class="featureDetail-body">
      <v-container class="body-inner">
        <v-row>
          <v-col cols="12" sm="7" class="img-box">
            <span class="fmockup-box">
              <img class="fmockup" alt="framed-mockup" src="../assets/w_mockup_frame.png" />
            </span>
            <swiper ref="screenSwiper" :options="swiperOptions" :auto-update="true">
              <swiper-slide><img class="screen" src="../assets/screens/dummy.png" alt="screen" /></swiper-slide>
              <swiper-slide><img class="screen" src="../assets/screens/feedback_card.png" alt="feedback-card" /></swiper-slide>
              <swiper-slide><img class="screen" src="../assets/screens/nutrition_graph.png" alt="nutrition-graph" /></swiper-slide>
              <swiper-slide><img class="screen" src="../assets/screens/food_recommendation.png" alt="food-recommendation" /></swiper-slide>
              <swiper-slide><img class="screen" src="../assets/screens/dummy.png" alt="screen" /></swiper-slide>
            </swiper>
            <span class="desc-ref-box" v-if="$vuetify.breakpoint.smAndDown">
              <p class="desc-ref">* 다이어트 프렌즈는 <strong>한국영양학회</strong>의 연구와 권장사항을 기준으로 </p>
              <p class="desc-ref">정보를 제공하고 있습니다.</p>
            </span>
          </v-col>
          <v-col cols="12" sm="5" class="desc-box">
            <div class="page-nav">
            <ul class="featureDetail-menus">
              <li class="featureDetail-menu" v-for="(title, index) in featureSlides" v-bind:class="{ active : featureDetailSlideIndex === index }" v-bind:key="title" @click="moveTo(index)">{{title}}</li>
            </ul>
            </div>
            <swiper ref="descSwiper" :options="descSwiperOptions">
              <swiper-slide class="desc-slide slide-1" v-for="(desc,index) in descs" v-bind:key="index">
                <div class="desc-slide-inner d-flex justify-center align-start flex-column">
                  <p class="desc-title" v-html="desc.title"></p>
                  <p class="desc-text" v-html="desc.text"></p>
                </div>
              </swiper-slide>
            </swiper>
            <div class="desc-ref-box" v-if="!$vuetify.breakpoint.smAndDown">
              <span class="img-box">
                <img class="page-ramhee" src="../assets/smart.png" alt="ramhee" />
              </span>
              <span class="text-box">
                <p class="desc-ref">다이어트 프렌즈는 <strong>한국영양학회</strong>의 연구와 권장사항을 기준으로 정보를 제공하고 있습니다.</p>
              </span>
            </div>
            <div class="swiper-nav">
              <span class="swiper-nav-box left" v-if="featureDetailSlideIndex !== 0">
                <a class="swiper-nav-btn"><font-awesome-icon :icon="['fas','chevron-left']" @click="moveToPrev"></font-awesome-icon></a>
              </span>
                  <span class="swiper-nav-box right" v-if="featureDetailSlideIndex !== (descs.length - 1)">
                <a class="swiper-nav-btn"><font-awesome-icon :icon="['fas','chevron-right']" @click="moveToNext"></font-awesome-icon></a>
              </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
    export default {
        name: "FeatureDetail",
        props: ['isFeatureDetailPageScrolled'],
        watch: {
            isFeatureDetailPageScrolled: function (isCurrent) {
              isCurrent ? this.isShowBg = true : this.isShowBg = false;
          },
        },
        data: function () {
          let that = this;
          return {
            featureDetailSlideIndex: 0,
            featureSlides: ['피드백 카드', '영양소 그래프', '식단 추천'],
            isShowBg: false,
            descs: [{
               title: '<strong>혼자는 어려운 식습관 개선</strong> <br/>람희가 도와줄게요',
               text: '람희는 매 끼니마다 내가 먹은 음식의 칼로리와 영양소를 분석해 내 식사에서 칭찬할 부분과 주의할 부분을 콕 짚어서 알려줘요. 일주일 간의 식습관까지 고려해 체계적으로 관리해 준답니다.',
            }, {
                title: '<strong>하루 영양소, 얼마나 먹었는지</strong> <br/>람희가 알려줄게요',
                text: '오늘 탄수화물을 너무 많이 먹진 않았는지, 단백질이 부족한 건 아닌지 걱정하지 마세요. 영양소 그래프를 통해 칼로리와 3대 영양소는 물론, 당과 나트륨, 그리고 물의 적정 섭취량을 한눈에 알 수 있어요.',
            }, {
                title: '<strong>매일 샐러드만 먹기 힘들다면</strong> <br/>람희가 추천해 줄게요',
                text: '오늘 먹은 음식을 람희에게 말해주면 다이어트 칼로리는 지키면서 필수 영양소도 꼭 채워주는 건강한 식단을 추천해 드려요. 똑똑한 람희가 수 만개의 식단 조합 중에서 추천해 준답니다.',
            }],
            swiperOptions: {
                initialSlide: 0,
                loop: false,
                slidesPerView: 3,
                slidesPerGroup: 1,
                loopFillGroupWithBlank: true,
                on: {
                    slideChangeTransitionStart: (e) => {
                        that.featureDetailSlideIndex = e.activeIndex;
                        that.descSwiper.slideTo(e.activeIndex);
                    }
                }
            },
            descSwiperOptions: {
                initialSlide: 0,
                loop: false,
                resistance: false,
                on: {
                    slideChangeTransitionStart: (e) => {
                        that.featureDetailSlideIndex = e.activeIndex;
                        that.swiper.slideTo(e.activeIndex);
                    }
                }
            },
          }
        },
        methods: {
          moveTo: function(index) {
            this.swiper.slideTo(index);
            this.descSwiper.slideTo(index);
          },
          moveToPrev: function() {
            this.featureDetailSlideIndex > 0 ? this.moveTo((this.featureDetailSlideIndex - 1)) : false;
          },
          moveToNext: function() {
              this.featureDetailSlideIndex < (this.descs.length - 1) ? this.moveTo((this.featureDetailSlideIndex + 1)) : false;
          },
        },
        computed: {
            swiper() {
                return this.$refs.screenSwiper.$swiper;
            },
            descSwiper() {
                return this.$refs.descSwiper.$swiper;
            }
        },
        mounted() {
            this.$vuetify.breakpoint.mobile ? this.swiper.allowTouchMove = true : this.swiper.allowTouchMove = false;
        }
    }
</script>

<style lang="scss" scoped>
@import '../variables.scss';
#featureDetail.show-mobile {
  overflow: visible !important;
  height: auto !important;
  .img-box {
    order: 2;
    height: auto !important;
    .desc-ref-box {
      display: block;
      margin-top: 1rem;
      padding-left: 1.5rem;
      .desc-ref {
        margin: 0;
        font-size: 0.8em;
        color: $softBlueColor;
      }
    }
  }
  .desc-box {
    margin-top: -40px !important;
    order: 1;
    height: auto !important;
    .featureDetail-menus {
      margin-bottom: 1rem !important;
    }
    .desc-title {
      font-size: 1.6em !important;
    }
    .page-ramhee {
      display: none !important;
    }
  }
}
#featureDetail {
  padding: 4rem 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #f6f6f6;
  /*animate object*/
  .showBg-enter-active {
    animation: fade-in-top .5s;
  }
  .showBg-leave-active {
    animation: fade-in-top .5s reverse;
  }
  .featureDetail-body {
    position: relative;
    height: 100%;
    width: 100%;

    .body-inner {
      height: 100%;
      position: relative;
      .row {
        height: 100%;
        padding: 0;

        > div {
          height: 100%;
        }
      }
    }
    .swiper-container{
      width: 100%;
      height: 100%;
      position: relative;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      display: flex;
      overflow: hidden;
    }

    .img-box {
      width: 100%;
      position: relative;
      .fmockup-box {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 0;

        .fmockup {
          display: none;
          width: auto;
          height: 98%;
        }
      }
      .swiper-slide {
        opacity: 0.44;
        height: 100%;
        width: 100%;
        z-index: 9;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        display: flex;
        img {
          height: auto;
          width: 76%;
          border: $basicBorder;
          border-radius: 4px;
        }
      }
      .swiper-slide.swiper-slide-next {
        opacity: 1;
        height: 100%;
        z-index: 99;
        img {
          height: auto;
          width: 100%;
        }
      }
      .swiper-slide.swiper-slide-active {
      }
    }
    .desc-box {
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      .swiper-container {
        height: auto;
      }

      .swiper-nav {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        z-index: 0;
        display: none;

        .swiper-nav-btn {
          font-size: 1.4em;
          color: $softBlueColor;
          padding: 1rem;
          z-index: 999;
        }
        .swiper-nav-box {
          position: absolute;
          transform: translate(-60%,0);
          bottom: 60%;
        }
        .swiper-nav-box.left {
          left: 10px;
        }
        .swiper-nav-box.right {
          right: -48px;
        }
      }
      .page-nav {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        margin-bottom: 1rem;
      }
      .featureDetail-menus {
        display: flex;
        flex-direction: row;
        padding-left: 2rem;
        margin-bottom: 2rem;

        .featureDetail-menu {
          font-size: 1em;
          font-family: $basicFont;
          font-weight: bold;
          margin-right: 0.4rem;
          padding: 0.6rem;
          color: $basicFontColor;
          cursor: pointer;
          border-bottom: 2px solid transparent;
        }
        .active {
          color: black;
          border-bottom: 2px solid $primaryBlueColor;
        }
      }
      .page-title-box {
        padding-left: 2rem;
        margin-bottom: 1rem;
      }

      .desc-ref-box {
        margin-top: 1rem;
        padding-left: 1.5rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .img-box {
          width: auto;
          .page-ramhee {
            padding-right: 2rem;
            width: auto;
            height: 60px;
            display: inline-block;
          }
        }
        .text-box {
        }
        .desc-ref {
          margin: 0;
          font-size: 0.8em;
          max-width: 66%;
          line-height: 1.6em;
          color: $softBlueColor;
          word-break: keep-all;
        }
      }

      .desc-slide {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;

        .desc-slide-inner {
          padding: 0 1rem 0 2rem;
        }
        .desc-title {
          font-size: 1.8em;
          font-weight: normal;
          font-family: $basicFont;
          color: $basicFontColor;
          margin-bottom: 1rem;
        }
        .desc-text {
          word-break: keep-all;
          max-width: 400px;
          font-color: $basicFontColor;
          font-family: $basicFont;
          font-size: 1em;
          width: 100%;
          line-height: 2em;
          text-align: justify;
        }
      }
    }
  }
}
</style>
